import * as types from '../../actions/shopList/shopListActionTypes';
import {
  Shop,
  FilterOption,
  AreaOption,
  CurrentLocation,
  SearchParams,
  FilterState,
} from '../../../pages/ShopList/types';

export interface ShopListState {
  searchMode: 'keyword' | 'map';
  searchParams: SearchParams;
  filters: FilterState;
  shops: Shop[];
  totalCount: number;
  currentLocation: CurrentLocation | null;
  selectedShopId: string | null;
  isAnnexSelected: boolean;
  loading: boolean;
  loaded: boolean;
  error: string | null;
  areaOptions: AreaOption[];
  facilityOptions: FilterOption[];
  serviceOptions: FilterOption[];
}

const initialState: ShopListState = {
  searchMode: 'keyword',
  searchParams: {
    area: '',
    keyword: '',
  },
  filters: {
    facilities: [],
    services: [],
  },
  shops: [],
  totalCount: 0,
  currentLocation: null,
  selectedShopId: null,
  isAnnexSelected: false,
  loading: false,
  loaded: false,
  error: null,
  areaOptions: [],
  facilityOptions: [],
  serviceOptions: [],
};

export const shopListReducer = (state = initialState, action: any): ShopListState => {
  switch (action.type) {
    case types.SET_SEARCH_MODE:
      return {
        ...state,
        searchMode: action.payload,
      };

    case types.SET_SEARCH_PARAMS:
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          ...action.payload,
        },
      };

    case types.SET_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };

    case types.CLEAR_FILTERS:
      return {
        ...state,
        filters: {
          facilities: [],
          services: [],
        },
      };

    case types.FETCH_SHOPS_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };

    case types.FETCH_SHOPS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        shops: action.payload.shops,
        totalCount: action.payload.totalCount,
      };

    case types.FETCH_SHOPS_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload,
      };

    case types.FETCH_SHOPS_INITIAL:
      return {
        ...state,
        loading: false,
        loaded: false,
        shops: [],
        totalCount: 0,
      };

    case types.TOGGLE_BOOKMARK_SUCCESS:
      return {
        ...state,
        shops: state.shops.map((shop) =>
          shop.id === action.payload.shopId ? { ...shop, isBookmarked: action.payload.isBookmarked } : shop,
        ),
      };

    case types.SET_SELECTED_SHOP:
      return {
        ...state,
        selectedShopId: action.payload.shopId,
        isAnnexSelected: action.payload.isAnnexSelected,
      };

    case types.SET_CURRENT_LOCATION:
      return {
        ...state,
        currentLocation: action.payload,
      };

    case types.FETCH_FILTER_OPTIONS_SUCCESS:
      return {
        ...state,
        facilityOptions: action.payload.facilities,
        serviceOptions: action.payload.services,
      };

    case types.FETCH_AREA_OPTIONS_SUCCESS:
      return {
        ...state,
        areaOptions: action.payload,
      };

    default:
      return state;
  }
};

export default shopListReducer;
